"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const hoist_non_react_statics_1 = tslib_1.__importDefault(require("hoist-non-react-statics"));
const lodash_1 = require("lodash");
const victory_core_1 = require("victory-core");
const ChartTheme_1 = require("../ChartTheme");
var ChartLabelDirection;
(function (ChartLabelDirection) {
    ChartLabelDirection["rtl"] = "rtl";
    ChartLabelDirection["ltr"] = "ltr";
    ChartLabelDirection["inherit"] = "inherit";
})(ChartLabelDirection = exports.ChartLabelDirection || (exports.ChartLabelDirection = {}));
var ChartLabelPlacement;
(function (ChartLabelPlacement) {
    ChartLabelPlacement["parallel"] = "parallel";
    ChartLabelPlacement["perpendicular"] = "perpendicular";
    ChartLabelPlacement["vertical"] = "vertical";
})(ChartLabelPlacement = exports.ChartLabelPlacement || (exports.ChartLabelPlacement = {}));
exports.ChartLabel = (_a) => {
    var { style } = _a, rest = tslib_1.__rest(_a, ["style"]);
    const applyDefaultStyle = (customStyle) => lodash_1.defaults(customStyle, {
        fontFamily: ChartTheme_1.ChartCommonStyles.label.fontFamily,
        fontSize: ChartTheme_1.ChartCommonStyles.label.fontSize,
        letterSpacing: ChartTheme_1.ChartCommonStyles.label.letterSpacing
    });
    const newStyle = Array.isArray(style) ? style.map(applyDefaultStyle) : applyDefaultStyle(style);
    return React.createElement(victory_core_1.VictoryLabel, Object.assign({ style: newStyle }, rest));
};
// Note: VictoryLabel.role must be hoisted
hoist_non_react_statics_1.default(exports.ChartLabel, victory_core_1.VictoryLabel);
//# sourceMappingURL=ChartLabel.js.map